import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from "@angular/router";
import { catchError } from "rxjs/operators";
import { SessionService } from "./session.service";
import { EventDispatcherService } from "./shared/services/event-dispatcher/event-dispatcher.service";

@Injectable()
export class LogoutOn401Interceptor implements HttpInterceptor {

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private readonly eventDispatcher: EventDispatcherService,
  ) {
  }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && !request.url.includes('/login')) {
                  this.eventDispatcher.dispatchEvent('logout', {});
                  this.sessionService.clear();
                  this.router.navigate(['/login']); // Redirect to login page
                }
                return throwError(() => error);
            })
        );
    }
}
